import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { retrieveUserTypes } from "../../../redux/slices/userType/userTypeSlice";

import "./UserType.css";

import professionalPic from "../../../assets/images/professionals.svg";
import reviewerPic from "../../../assets/images/reviewer-icon.png";
import ServerUpgradtionModal from "../../ServerUpgradtionModal";
import { ModuleListShimmer } from "../../../utils/certificateShimmer/CourseListShimmer";
import othersPic from "../../../assets/images/others-icon.svg";
import RCIProfessionalPopup from "./RciProfessionalPopup";
import creProgrammePic from "../../../assets/images/cre_programme.svg";
import defaultPic from "../../../assets/images/default-user.svg";

const UserTypeScreen = (props) => {
  const { handleChange, getTextTranslated } = props;
  const dispatch = useDispatch();

  const [activeUserTypes, setActiveUserTypes] = useState();
  const [serverError, setServerError] = useState(false);
  const [shimmer, setShimmer] = useState(true);

  const [selectedUserType, setSelectedUserType] = useState(null);
  const [showSwitchCREProgrammePopup, setShowSwitchCREProgrammePopup] =
    useState(false);

  const getUserTypes = async () => {
    try {
      const dispatchUserTypes = await dispatch(retrieveUserTypes()).unwrap();
      if (!dispatchUserTypes) {
        setShimmer(false);
        setServerError(true);
        return;
      }

      // Define the new user type object
      // const rciProfessional = {
      //   id: 12,
      //   name: "CRE PROGRAMME",
      //   icon: null,
      //   isShowOnApp: 1,
      //   createdDate: "2025-10-13T11:56:00",
      //   updatedDate: null,
      //   createdBy: 82,
      //   updatedBy: null,
      //   status: 1,
      //   priority: 12,
      // };

      // Append it to the existing response array
      //const updatedResponse = [...dispatchUserTypes.response, rciProfessional];
      //console.log(updatedResponse, "static usertype response");
      // Set the updated response
      //setActiveUserTypes(updatedResponse);

      setActiveUserTypes(dispatchUserTypes.response);
      setShimmer(false);

      return dispatchUserTypes;
    } catch (error) {
      console.log(error);
      setShimmer(false);
    }
  };

  const handleRCIPopup = (userTypeId) => {
    if (userTypeId === 7) {
      setShowSwitchCREProgrammePopup(true);
    } else {
      setShowSwitchCREProgrammePopup(false);
    }
  };
  useEffect(() => {
    getUserTypes();

    const clearLocalStorageExcpeptOneKey = () => {
      const valueToKeep = localStorage.getItem("l_id");
      localStorage.clear();
      localStorage.setItem("l_id", valueToKeep);
    };
    // localStorage.clear();
    clearLocalStorageExcpeptOneKey("l_id");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {shimmer === true ? (
        <>
          <h1>
            <br></br>
          </h1>
          <ModuleListShimmer />
          <ModuleListShimmer />
          <h1>
            <br></br> <br></br>
          </h1>
        </>
      ) : (
        <>
          <h1 className="text-[26px] lg:text-[30px] font-medium mt-[0px]">
            {getTextTranslated?.data?.length > 0
              ? getTextTranslated?.data?.filter(
                  (item) => item.pageKey === "please_select_txt"
                )[0]?.keyValue
              : " Please select your Role"}
          </h1>

          {/* <div className="lg:my-3 my-6 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full sm:w-[80%] 2xl:w-[80%] m-auto h-[calc(100vh-65vh)] lg:h-[calc(100vh-65vh)] max-h-[58vh] overflow-x-auto overflow-y-scroll"> */}
          <div className="lg:my-3 my-6 grid grid-cols-2 sm:grid-cols-3 gap-4 w-full sm:w-[80%] 2xl:w-[80%] m-auto h-[calc(100vh-65vh)] lg:h-[calc(100vh-65vh)] max-h-[58vh] overflow-x-auto overflow-y-auto">
            {activeUserTypes?.map((userType) => (
              // {userTypes?.map((userType) => (
              <div
                key={userType.id}
                className="mx-3 md:w-1/8 lg:w-[25%s] lg:w-auto w-[40%] md:w-[20%] my-[10px] lg:my-0 flex"
              >
                <label className="mr-2 w-full flex flex-col items-center">
                  <label htmlFor={userType.id} className="relative">
                    <input
                      className="profile-check mr-2"
                      type={"radio"}
                      name="userType"
                      id={userType.id}
                      checked={selectedUserType === userType.id}
                      onChange={(e) => {
                        handleChange(e, "userType");
                        setSelectedUserType(userType.id);
                        handleRCIPopup(userType.id);
                      }}
                      required
                    />
                    {userType.name === "PARENT" ? (
                      <div className="profile-type-img">
                        <img src="../Images/parents-2.svg" alt="" />
                      </div>
                    ) : userType.id === 3 ? (
                      <div className="profile-type-img">
                        <img src="../Images/teacher-icon.svg" alt="" />
                      </div>
                    ) : userType.id === 7 ? (
                      <div className="profile-type-img">
                        <img src="../Images/special-educator-icon.svg" alt="" />
                      </div>
                    ) : userType.id === 8 ? (
                      <div className="profile-type-img">
                        <img src={professionalPic} alt="" />
                        {/* <img src="../Images/special-educator-icon.svg" alt="" /> */}
                      </div>
                    ) : userType.id === 9 ? (
                      <div className="profile-type-img">
                        <img src={reviewerPic} alt="" />
                        {/* <img src="../Images/special-educator-icon.svg" alt="" /> */}
                      </div>
                    ) : userType.id === 11 ? (
                      <div className="profile-type-img">
                        <img src={othersPic} alt="OTHERS" />
                      </div>
                    ) : userType.id === 12 ? (
                      <div className="profile-type-img">
                        <img src={creProgrammePic} alt="CRE Programme" />
                      </div>
                    ) : (
                      <>
                        <div className="profile-type-img">
                          <img src={defaultPic} alt="Default" />
                        </div>
                      </>
                    )}
                  </label>
                  {/* <img src={userType.icon} alt={""} /> */}
                  <p className="text-[#101942] mt-2 font-semibold md:text-[14px]">
                    {userType.name === "PARENT"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_parent"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "TEACHER"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_teacher"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "SPECIAL EDUCATOR"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_special_educator"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "REVIEWER"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_reviewer"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "PROFESSIONALS"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_professional"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "OTHERS"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_others"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name === "CRE PROGRAMME"
                      ? getTextTranslated?.data?.length > 0
                        ? getTextTranslated?.data?.filter(
                            (item) => item?.pageKey === "key_cre_programme"
                          )[0]?.keyValue
                        : userType.name
                      : userType.name}
                  </p>
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      <ServerUpgradtionModal
        show={serverError}
        setShow={setServerError}
        apiCall={getUserTypes}
      />

      <RCIProfessionalPopup
        visible={showSwitchCREProgrammePopup}
        onClose={() => setShowSwitchCREProgrammePopup(false)}
        getTranslateText={getTextTranslated}
        setSelectedUserType={setSelectedUserType}
        handleChange={handleChange}
      />
    </>
  );
};

export default UserTypeScreen;
